<template>
    <div>
        <ul class="list-none p-0 m-0">
            <li class="py-1"><a class="text-muted" :class="{'font-bold': !conv }" href="#"
                                @click.prevent="download('convention-assistance')"><i v-if="icons"
                                                                                      class="fal fa-fw fa-lg text-info mr-2"
                                                                                      :class="{'fa-download': conv, 'fa-check': conv}"/>Convention
                d’assistance</a></li>
            <li class="py-1"><a class="text-muted" :class="{'font-bold': !cgv }" href="#"
                                @click.prevent="download('cgv')"><i v-if="icons" class="fal fa-fw fa-lg text-info mr-2"
                                                                    :class="{'fa-download': cgv, 'fa-check': cgv}"/>Conditions
                Générales de Ventes</a></li>
            <li class="py-1"><a class="text-muted" :class="{'font-bold': !tarif }" href="#"
                                @click.prevent="download('mission-tarifs')"><i v-if="icons"
                                                                               class="fal fa-fw fa-lg text-info mr-2"
                                                                               :class="{'fa-download': !tarif, 'fa-check': tarif}"/>Tarif
                des prestations</a></li>
        </ul>
    </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'LegalLinks',
  props: {
    icons: {type: Boolean, default: false}
  },
  computed: {
    conv () {
      return this.$store.state.user.activeUser.doc_convention
    },
    cgv () {
      return this.$store.state.user.activeUser.doc_cgv
    },
    tarif () {
      return this.$store.state.user.activeUser.doc_tarif
    }
  },
  methods: {
    ...mapActions('document', ['downloadDocument']),
    download (name) {
      this.downloadDocument({
        name,
        filename: `${name}.pdf`
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
